import { useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { REDACTED_FIELD } from '../../../../config/logrocket';
import { usePersona } from '../../../hooks/usePersona';

const AccountLink = ({
  account = {},
  accountId,
  children,
  primeCache = false,
}: any) => {
  const queryClient = useQueryClient();
  const persona = usePersona();

  let timer: any;
  const prefetchAccountData = (clearTimer = false) => {
    return () => {
      if (clearTimer || !primeCache) {
        clearTimeout(timer);
        return;
      }

      timer = setTimeout(
        () =>
          queryClient.setQueryData(
            ['account-summary-data', accountId],
            account
          ),
        500
      );
    };
  };

  return (
    <Link
        onMouseEnter={prefetchAccountData()}
        onMouseLeave={prefetchAccountData(true)}
        to={`${persona.basePath}/account/${accountId}`}
        className={REDACTED_FIELD}
      >
        {children}
      </Link>
  );
};

export default AccountLink;
